import React, { useState } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { BiMoveVertical } from "react-icons/bi";
import ViewMappings from "./ViewMappings";
import { useSelector, useDispatch } from "react-redux";
import { getMappings, sortMappings } from "../store/workspaceSlice";
const DraggableMappings = () => {
  const mappings = useSelector(getMappings);

  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active?.id !== over?.id) {
      const oldIndex = mappings.findIndex((col) => col._id === active.id);
      const newIndex = mappings.findIndex((col) => col._id === over.id);
      const sortedMappings = arrayMove(mappings, oldIndex, newIndex);

      dispatch(sortMappings(sortedMappings));
    }
  };

  return (
    <div className="bg-gray-50 rounded-md shadow mb-2">
      <div
        className="flex justify-between items-center cursor-pointer p-2 rounded hover:bg-gray-300 border border-gray-400 shadow hover:outline-none text-gray-500"
        onClick={() => {
          (mappings.length || isOpen) && toggleAccordion();
        }}
      >
        <div className="text-gray-500">{mappings.length || ""}</div>
        <h2 className="text-red-600 font-medium">Mappings</h2>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={mappings.map((col) => col._id)}>
          <ul
            className={`space-y-2 bg-gray-50 rounded-md ${
              isOpen ? "max-h-80 py-4" : "max-h-0"
            }  overflow-y-auto transition-all duration-300`}
          >
            {mappings.map((column, index) => (
              <SortableItem
                key={column._id}
                id={column._id}
                index={index}
                column={column}
              />
            ))}
          </ul>
        </SortableContext>
      </DndContext>
    </div>
  );
};

function SortableItem({ id, column, index }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className=" flex items-center rounded shadow border border-gray-300 cursor-move overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="p-2 h-full bg-red-400 hover:bg-red-500 active:bg-red-600 text-xl rounded overflow-clip ">
        <BiMoveVertical />
      </div>
      <div className="w-full">
        <ViewMappings column={column} index={index} />
      </div>
    </li>
  );
}

export default DraggableMappings;
